import { render } from "./InspectionPlanDetail.vue?vue&type=template&id=3902e1b0"
import script from "./InspectionPlanDetail.vue?vue&type=script&lang=js"
export * from "./InspectionPlanDetail.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__